import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "arrowPlacement", "title"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef } from 'react';
import { Box } from '@mui/material';
import { StyledTooltip } from './tooltip.styles';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Tooltip component.
 *
 * @author Ihar Kazlouski
 * @function Tooltip
 * @category components
 * @return {FC} tooltip component.
 */
var Tooltip = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      arrowPlacement = _ref.arrowPlacement,
      title = _ref.title,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(StyledTooltip, _objectSpread(_objectSpread({}, restProps), {}, {
    arrowPlacement: arrowPlacement,
    title: title,
    children: /*#__PURE__*/_jsx(Box, {
      ref: ref,
      children: children
    })
  }));
});
Tooltip.displayName = 'Tooltip';
export { Tooltip };